<template>
  <Teleport to="body">
    <!-- Overlay -->
    <div class="fixed inset-0 z-[250] bg-black/50 flex items-center justify-center p-3 md:p-8" @click="cerrar">
      <!-- Modal -->
      <div
        class="relative w-full max-w-[1200px] bg-white rounded-[32px] overflow-hidden shadow-2xl h-[90vh] md:h-[620px]"
        role="dialog" aria-modal="true" @click.stop>
        <!-- Botón cerrar -->
        <button type="button" class="absolute z-[10]
                 top-4 right-4 md:top-6 md:right-6
                 w-12 h-12 rounded-full bg-ROJO_LEON
                 flex items-center justify-center shadow-lg
                 hover:opacity-90 transition" aria-label="Cerrar" @click="cerrar">
          <svg class="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none">
            <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
          </svg>
        </button>

        <!-- Contenido -->
        <div class="flex flex-col md:flex-row w-full h-full">
          <div class="w-full md:w-1/2 h-[260px] md:h-full">
            <img :src="image_src" :alt="image_alt" class="w-full h-full object-cover" loading="lazy" />
          </div>

          <div class="w-full md:w-1/2 flex-1 md:flex-none bg-GRIS_CLARO">
            <div class="h-full overflow-y-auto px-4 pb-8 pt-16 md:px-12 md:pt-20 md:pb-10">
              <FormularioAceite variant="modal" :containerClass="[
                'w-full max-w-[520px]',
                'mx-auto',
                'bg-transparent',
                'shadow-none',
                'px-0 pt-0 pb-0',
                'rounded-2xl'
              ].join(' ')" @callContact="emit('callContact')" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import FormularioAceite from '~/components/Formularios/FormularioAceite.vue'

const props = defineProps({
  image_src: { type: String, default: '/img/aceites/imagenes/jefe-local.png' },
  image_alt: { type: String, default: 'Técnico de servicio automotriz' },
})

const emit = defineEmits(['close', 'callContact'])

const cerrar = () => emit('close')

const on_keydown = (e) => {
  if (e.key === 'Escape') cerrar()
}

onMounted(() => {
  document.body.classList.add('popup-active')
  window.addEventListener('keydown', on_keydown)
})

onBeforeUnmount(() => {
  document.body.classList.remove('popup-active')
  window.removeEventListener('keydown', on_keydown)
})
</script>

<style>
:global(body.popup-active) {
  overflow: hidden !important;
}
</style>
